import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import api from "../../../services/api";
import { useSelector } from "react-redux";
import Loader from "../../../core/common/loader";
import { showBasicAlert } from "../../../core/common/useAlert";
import { company_short_name } from "../../../environment";

const SuperAdminDashboard = () => {
  const routes = all_routes;

  const sendReminder = async () => {
    try {
      showBasicAlert("Reminder sent successfully!");
    } catch (error) {
      showBasicAlert("Failed to send reminder.");
    }
  };
  const user = useSelector((state: any) => state.user.user);

  const [responseDataAdminDash, setResponseDataAdminDash] = useState<
    any | undefined
  >(undefined);

  const [ApexChart, setApexChart] = useState<any>({
    series: [
      {
        name: "Company",
        data: [], // Data for Jan-Dec
      },
    ],
    chart: {
      type: "bar",
      width: 70,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: false,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: true, // Keep sparkline enabled
      },
    },
    markers: {
      size: 0,
      colors: ["#F26522"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2.5,
      curve: "smooth",
    },
    colors: ["#FF6F28"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ], // Full year of months
      labels: {
        show: true,
      },
    },
    tooltip: {
      show: true,
      theme: "dark",
      fixed: {
        enabled: false,
      },
      x: {
        show: true,
      },
      marker: {
        show: false,
      },
    },
  });

  const [ApexChart3, setApexChart3] = useState<any>({
    series: [
      {
        name: "Subscriber",
        data: [], // Data for Jan-Dec
      },
    ],
    chart: {
      type: "bar",
      width: 70,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: false,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: true, // Keep sparkline enabled
      },
    },
    markers: {
      size: 0,
      colors: ["#F26522"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2.5,
      curve: "smooth",
    },
    colors: ["#FF6F28"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ], // Full year of months
      labels: {
        show: true,
      },
    },
    tooltip: {
      show: true,
      theme: "dark",
      fixed: {
        enabled: false,
      },
      x: {
        show: true,
      },
      marker: {
        show: false,
      },
    },
  });

  const [ApexChart4, setApexChart4] = useState<any>({
    series: [
      {
        name: "Earning",
        data: [],
      },
    ],
    chart: {
      type: "bar",
      width: 70,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: false,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: true, // Keep sparkline enabled
      },
    },
    markers: {
      size: 0,
      colors: ["#F26522"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2.5,
      curve: "smooth",
    },
    colors: ["#FF6F28"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ], // Full year of months
      labels: {
        show: true,
      },
    },
    tooltip: {
      show: true,
      theme: "dark",
      fixed: {
        enabled: false,
      },
      x: {
        show: true,
      },
      marker: {
        show: false,
      },
    },
  });

  const [CompanyChart, setCompanyChart] = useState<any>({
    chart: {
      height: 240,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    colors: ["#212529"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        borderRadius: 10,
        borderRadiusWhenStacked: "all",
        horizontal: false,
        endingShape: "rounded",
        colors: {
          backgroundBarColors: ["#f3f4f5"], // Background color for bars
          backgroundBarOpacity: 0.5,
          hover: {
            enabled: true,
            borderColor: "#F26522", // Color when hovering over the bar
          },
        },
      },
    },
    series: [
      {
        name: "Company",
        data: [],
      },
    ],
    xaxis: {
      categories: ["M", "T", "W", "T", "F", "S", "S"],
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
      },
    },
    yaxis: {
      labels: {
        offsetX: -15,
        show: false,
      },
    },
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 5,
      padding: {
        left: -8,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false, // Disable data labels
    },
    fill: {
      opacity: 1,
    },
  });

  const [RevenueChart, setRevenueChart] = useState<any>({
    chart: {
      height: 230,
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    colors: ["#FF6F28", "#F8F9FA"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        borderRadius: 5,
        borderRadiusWhenStacked: "all",
        horizontal: false,
        endingShape: "rounded",
      },
    },
    series: [
      {
        name: "Income",
        data: [],
      },
    ],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
      },
    },
    yaxis: {
      min: 0, // Set the minimum value of the Y-axis to 0
      max: 100,
      labels: {
        offsetX: -15,
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
        formatter: function (value: any) {
          return value + "K"; // Divide by 1000 and append 'K'
        },
      },
    },
    grid: {
      borderColor: "transparent",
      strokeDashArray: 5,
      padding: {
        left: -8,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: function (val: any) {
          return val / 10 + " k";
        },
      },
    },
    fill: {
      opacity: 1,
    },
  });

  const [PlanChart, setPlanChart] = useState<any>({
    chart: {
      height: 240,
      type: "donut",
      toolbar: {
        show: false,
      },
    },
    colors: ["#FFC107", "#1B84FF", "#F26522"],
    series: [],
    labels: [],
    plotOptions: {
      pie: {
        donut: {
          size: "50%",
          labels: {
            show: false,
          },
          borderRadius: 30,
        },
      },
    },
    stroke: {
      lineCap: "round",
      show: true,
      width: 0, // Space between donut sections
      colors: "#fff",
    },
    dataLabels: {
      enabled: false,
    },
    legend: { show: false },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 180,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });

  useEffect(() => {
    // This will run when the component mounts
    const fetchDashboardData = async () => {
      try {
        const signature = localStorage.getItem("signature");
        const response = await api.post("userService/adminDashboardData", {
          signature,
        });
        setResponseDataAdminDash(response.data);

        const data1 = response.data.data.companies_month_wise.map(
          (item: { count: any }) => parseInt(item.count)
        );
        setApexChart((prevState: any) => ({
          ...prevState,
          series: [
            {
              name: "Company",
              data: data1,
            },
          ],
        }));

        const data2 = response.data.data.total_subscribers_month_wise.map(
          (item: { count: any }) => parseInt(item.count)
        );
        setApexChart3((prevState: any) => ({
          ...prevState,
          series: [
            {
              name: "Subscriber",
              data: data2,
            },
          ],
        }));

        const data3 = response.data.data.earnings_month_wise.map(
          (item: { total_earning: any }) => parseInt(item.total_earning)
        );
        setApexChart4((prevState: any) => ({
          ...prevState,
          series: [
            {
              name: "Earning",
              data: data3,
            },
          ],
        }));

        const data4 = response.data.data.companies_week_wise.map(
          (item: { count: any }) => parseInt(item.count)
        );
        setCompanyChart((prevState: any) => ({
          ...prevState,
          series: [
            {
              name: "Company",
              data: data4,
            },
          ],
        }));

        const data5 = response.data.data.earnings_month_wise.map(
          (item: { total_earning: any }) => parseInt(item.total_earning) / 1000
        );
        setRevenueChart((prevState: any) => ({
          ...prevState,
          series: [
            {
              name: "Income",
              data: data5,
            },
          ],
        }));

        const series = response.data.data.topPlans.map(
          (item: { usage_percentage: any }) => parseInt(item.usage_percentage)
        );
        const label = response.data.data.topPlans.map((item: { name: any }) =>
          item.name.trim()
        );
      } catch (err) {}
    };

    fetchDashboardData();
  }, []);

  const [ApexChart2] = React.useState<any>({
    series: [
      {
        name: "Messages",
        data: [1, 2, 3, 4],
      },
    ],

    chart: {
      type: "bar",
      width: 70,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: false,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#F26522"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: !0,
      width: 2.5,
      curve: "smooth",
    },
    colors: ["#4B3088"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
      labels: {
        show: false,
      },
    },
    tooltip: {
      show: false,
      theme: "dark",
      fixed: {
        enabled: false,
      },
      x: {
        show: false,
      },

      marker: {
        show: false,
      },
    },
  });

  if (responseDataAdminDash === undefined) {
    return <Loader />;
  } else {
    return (
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Dashboard</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.superAdminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Superadmin</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Dashboard
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Welcome Wrap */}
          <div className="welcome-wrap mb-4">
            <div className=" d-flex align-items-center justify-content-between flex-wrap">
              <div className="mb-3">
                <h2 className="mb-1 text-white">
                  Welcome Back, {user?.userDetails.fname}
                </h2>
                <p className="text-light">
                  {responseDataAdminDash.data.todayCompanies} New Companies
                  Subscribed Today
                </p>
              </div>
              <div className="d-flex align-items-center flex-wrap mb-1">
                <Link
                  to={routes.superAdminCompanies}
                  className="btn btn-dark btn-md me-2 mb-2"
                >
                  Companies
                </Link>
                <Link
                  to={routes.superAdminPackages}
                  className="btn btn-light btn-md mb-2"
                >
                  All Packages
                </Link>
              </div>
            </div>
            <div className="welcome-bg">
              <ImageWithBasePath
                src="assets/img/bg/welcome-bg-02.svg"
                alt="img"
                className="welcome-bg-01"
              />
              <ImageWithBasePath
                src="assets/img/bg/welcome-bg-03.svg"
                alt="img"
                className="welcome-bg-02"
              />
              <ImageWithBasePath
                src="assets/img/bg/welcome-bg-01.svg"
                alt="img"
                className="welcome-bg-03"
              />
            </div>
          </div>
          {/* /Welcome Wrap */}
          <div className="row">
            {/* Total Companies */}
            <div className="col-xl-3 col-sm-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="avatar avatar-md bg-dark mb-3">
                      <i className="ti ti-building fs-16" />
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h2 className="mb-1">
                        {responseDataAdminDash.data.total_companies}
                      </h2>
                      <p className="fs-13">Total Companies</p>
                    </div>
                    <ReactApexChart
                      options={ApexChart}
                      series={ApexChart.series}
                      type="bar"
                      width={70}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Companies */}
            {/* Active Companies */}
            <div className="col-xl-3 col-sm-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="avatar avatar-md bg-dark mb-3">
                      <i className="ti ti-carousel-vertical fs-16" />
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h2 className="mb-1">
                        {" "}
                        {responseDataAdminDash.data.activeCompanies}
                      </h2>
                      <p className="fs-13">Active Companies</p>
                    </div>
                    <ReactApexChart
                      options={ApexChart2}
                      series={ApexChart2.series}
                      type="bar"
                      width={70}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Active Companies */}
            {/* Total Subscribers */}
            <div className="col-xl-3 col-sm-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="avatar avatar-md bg-dark mb-3">
                      <i className="ti ti-chalkboard-off fs-16" />
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h2 className="mb-1">
                        {responseDataAdminDash.data.totalSubscribers}
                      </h2>
                      <p className="fs-13">Total Subscribers</p>
                    </div>
                    <ReactApexChart
                      options={ApexChart3}
                      series={ApexChart3.series}
                      type="bar"
                      width={70}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Subscribers */}
            {/* Total Earnings */}
            <div className="col-xl-3 col-sm-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="avatar avatar-md bg-dark mb-3">
                      <i className="ti ti-businessplan fs-16" />
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h2 className="mb-1">
                        ₹{responseDataAdminDash.data.totalEarnings}
                      </h2>
                      <p className="fs-13">Total Earnings</p>
                    </div>
                    <ReactApexChart
                      options={ApexChart4}
                      series={ApexChart4.series}
                      type="bar"
                      width={70}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Earnings */}
          </div>
          <div className="row">
            {/* Companies */}
            <div className="col-xxl-3 col-lg-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Companies</h5>
                  <div className="mb-2">This Week</div>
                  {/* <div className="dropdown mb-2">
                    <Link
                      to="#"
                      className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-calendar me-1" />
                      This Week
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          This Month
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          This Week
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Today
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                </div>
                <div className="card-body">
                  <ReactApexChart
                    id="company-chart"
                    options={CompanyChart}
                    series={CompanyChart.series}
                    type="bar"
                    height={240}
                  />
                  <p className="f-13 d-inline-flex align-items-center">
                    <span
                      className={
                        responseDataAdminDash.data.percentageChanged
                          .percentageDifference > 0
                          ? "badge badge-success me-1"
                          : "badge badge-danger me-1"
                      }
                    >
                      +
                      {
                        responseDataAdminDash.data.percentageChanged
                          .percentageDifference
                      }
                      %
                    </span>{" "}
                    {responseDataAdminDash.data.percentageChanged
                      .currentMonthCount -
                      responseDataAdminDash.data.percentageChanged
                        .previousMonthCount +
                      " "}
                    Companies from last month
                  </p>
                </div>
              </div>
            </div>
            {/* /Companies */}
            {/* Revenue */}
            <div className="col-lg-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Revenue</h5>
                  <div className="mb-2">This Year</div>
                  {/* <div className="dropdown mb-2">
                    <Link
                      to="#"
                      className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-calendar me-1" />
                      2025
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          2024
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          2025
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          2023
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                </div>
                <div className="card-body pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="mb-1">
                      <h5 className="mb-1">
                        ₹{responseDataAdminDash.data.earningThisYear}
                      </h5>
                      <p>
                        <span className="text-success fw-bold">
                          +{responseDataAdminDash.data.differenceLastYear}%
                        </span>{" "}
                        increased from last year
                      </p>
                    </div>
                    <p className="fs-13 text-gray-9 d-flex align-items-center mb-1">
                      <i className="ti ti-circle-filled me-1 fs-6 text-primary" />
                      Revenue
                    </p>
                  </div>
                  <ReactApexChart
                    id="revenue-income"
                    options={RevenueChart}
                    series={RevenueChart.series}
                    type="bar"
                    height={230}
                  />
                </div>
              </div>
            </div>
            {/* /Revenue */}
            {/* Top Plans */}
            <div className="col-xxl-3 col-xl-12 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Top Plans</h5>
                  <div className="mb-2">This Year</div>
                  {/* <div className="dropdown mb-2">
                    <Link
                      to="#"
                      className="btn btn-white border btn-sm d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-calendar me-1" />
                      This Month
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          This Month
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          This Week
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Today
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                </div>
                <div className="card-body">
                  {/* <ReactApexChart
                    options={PlanChart}
                    series={PlanChart.series}
                    type="donut"
                    height={240}
                  /> */}
                  <>
                    {responseDataAdminDash.data.topPlans.map(
                      (item: any, index: any) => {
                        // Define the mapping between plan names and color classes
                        const colorMapping: any = {
                          Basic: "text-primary",
                          Advance: "text-warning",
                          Pro: "text-info",
                        };

                        // Get the color class for the current plan
                        const colorClass =
                          colorMapping[item.name] || "text-muted"; // Default to "text-muted" if no match

                        return (
                          <div
                            key={index}
                            className="d-flex align-items-center justify-content-between mb-2"
                          >
                            <p className="f-13 mb-0">
                              <i
                                className={`ti ti-circle-filled ${colorClass} me-1`}
                              />
                              {item.name}
                            </p>
                            <p className="f-13 fw-medium text-gray-9">
                              {Math.round(item.usage_percentage * 100) / 100}
                              {"%"}
                            </p>
                          </div>
                        );
                      }
                    )}
                  </>
                </div>
              </div>
            </div>
            {/* /Top Plans */}
          </div>
          <div className="row">
            {/* Recent Transactions */}
            <div className="col-xxl-4 col-xl-12 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Recent Transactions</h5>
                  {/* <Link
                    to={routes.superAdminPurchaseTransaction}
                    className="btn btn-light btn-md mb-2"
                  >
                    View All
                  </Link> */}
                </div>
                <div className="card-body pb-2">
                  <>
                    {responseDataAdminDash.data.purchase_history.map(
                      (item: any, index: any) => {
                        const dateObj = new Date(item.purchase_date);
                        // Get the year, month, and day components
                        const year = dateObj.getFullYear();
                        const month = String(dateObj.getMonth() + 1).padStart(
                          2,
                          "0"
                        ); // Month is 0-indexed
                        const day = String(dateObj.getDate()).padStart(2, "0"); // Ensure 2 digits for day
                        const formattedDate = `${year}-${month}-${day}`;
                        return (
                          <div
                            key={index}
                            className="d-sm-flex justify-content-between flex-wrap mb-3"
                          >
                            <div className="d-flex align-items-center mb-2">
                              <Link
                                to="javscript:void(0);"
                                className="avatar avatar-md bg-gray-100 rounded-circle flex-shrink-0"
                              >
                                <ImageWithBasePath
                                  src={item.companyLogo}
                                  className="img-fluid w-auto h-auto"
                                  alt="img"
                                />
                              </Link>
                              <div className="ms-2 flex-fill">
                                <h6 className="fs-medium text-truncate mb-1">
                                  {item.company_name}
                                </h6>
                                <p className="fs-13 d-inline-flex align-items-center">
                                  <span className="text-info">
                                    #{item.invoice_id}
                                  </span>
                                  <i className="ti ti-circle-filled fs-4 text-primary mx-1" />
                                  {formattedDate}
                                </p>
                              </div>
                            </div>
                            <div className="text-sm-end mb-2">
                              <h6 className="mb-1">
                                +₹{""}
                                {parseFloat(item.amount) + parseFloat(item.tax)}
                              </h6>
                              <p className="fs-13">{item.package_name}</p>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </>
                </div>
              </div>
            </div>
            {/* /Recent Transactions */}
            {/* Recently Registered */}
            <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Recently Registered</h5>
                  {/* <Link
                    to={routes.superAdminPurchaseTransaction}
                    className="btn btn-light btn-md mb-2"
                  >
                    View All
                  </Link> */}
                </div>
                <div className="card-body pb-2">
                  <>
                    {responseDataAdminDash.data.recently_register_company.map(
                      (item: any, index: any) => {
                        const dateObj = new Date(item.createdAt);
                        // Get the year, month, and day components
                        const year = dateObj.getFullYear();
                        const month = String(dateObj.getMonth() + 1).padStart(
                          2,
                          "0"
                        ); // Month is 0-indexed
                        const day = String(dateObj.getDate()).padStart(2, "0"); // Ensure 2 digits for day
                        const formattedDate = `${year}-${month}-${day}`;
                        return (
                          <div
                            key={index}
                            className="d-sm-flex justify-content-between flex-wrap mb-1"
                          >
                            <div className="d-flex align-items-center mb-2">
                              <Link
                                to="javscript:void(0);"
                                className="avatar avatar-md bg-gray-100 rounded-circle flex-shrink-0"
                              >
                                <ImageWithBasePath
                                  src={item.logo}
                                  className="img-fluid w-auto h-auto"
                                  alt="img"
                                />
                              </Link>
                              <div className="ms-2 flex-fill">
                                <h6 className="fs-medium text-truncate mb-1">
                                  {item.name}
                                </h6>
                                <p className="fs-13">{item.m_package.name}</p>
                              </div>
                            </div>
                            <div className="text-sm-end mb-2">
                              <h6 className="mb-1">
                                {item.city},{item.state},{item.country}
                              </h6>
                              <p className="fs-13">{formattedDate}</p>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Recent Plan Expired</h5>
                </div>
                <div className="card-body pb-2">
                  <div className="tab-content">
                    <div className="tab-pane fade show active" id="expired">
                      <>
                        {responseDataAdminDash.data.expired_plan.map(
                          (item: any, index: any) => {
                            const dateObj = new Date(item.expire_date);
                            // Get the year, month, and day components
                            const year = dateObj.getFullYear();
                            const month = String(
                              dateObj.getMonth() + 1
                            ).padStart(2, "0"); // Month is 0-indexed
                            const day = String(dateObj.getDate()).padStart(
                              2,
                              "0"
                            ); // Ensure 2 digits for day
                            const formattedDate = `${year}-${month}-${day}`;
                            return (
                              <div
                                key={index}
                                className="d-sm-flex justify-content-between flex-wrap mb-3"
                              >
                                <div className="d-flex align-items-center mb-2">
                                  <Link
                                    to="javscript:void(0);"
                                    className="avatar avatar-md bg-gray-100 rounded-circle flex-shrink-0"
                                  >
                                    <ImageWithBasePath
                                      src={item.companyLogo}
                                      className="img-fluid w-auto h-auto"
                                      alt="img"
                                    />
                                  </Link>
                                  <div className="ms-2 flex-fill">
                                    <h6 className="fs-medium text-truncate mb-1">
                                      <Link to="javscript:void(0);">
                                        {item.company_name}
                                      </Link>
                                    </h6>
                                    <p className="fs-13">
                                      Expired : {formattedDate}
                                    </p>
                                  </div>
                                </div>
                                <div className="text-sm-end mb-2">
                                  <Link
                                    to="#"
                                    className="link-info text-decoration-underline d-block mb-1"
                                    onClick={sendReminder}
                                  >
                                    Send Reminder
                                  </Link>
                                  <p className="fs-13">{item.package_name}</p>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Recent Plan Expired */}
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © {company_short_name}</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              {company_short_name}
            </Link>
          </p>
        </div>
      </div>
    );
  }
};

export default SuperAdminDashboard;
